import uuid from 'uuid';
export const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';
export const createGuid = () => uuid.v4();
